'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var injectSheet = require('react-jss');

var _classCallCheck = require('@babel/runtime/helpers/classCallCheck');

var _createClass = require('@babel/runtime/helpers/createClass');

var _inherits = require('@babel/runtime/helpers/inherits');

var _possibleConstructorReturn = require('@babel/runtime/helpers/possibleConstructorReturn');

var _getPrototypeOf = require('@babel/runtime/helpers/getPrototypeOf');

var classNames = require('classnames');

var _defineProperty = require('@babel/runtime/helpers/defineProperty');

var PropTypes = require('prop-types');

var _extends = require('@babel/runtime/helpers/extends');

var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');

var pobbleUser = require('pobble-components/dist/pobble-user');

var pobbleAvatar = require('pobble-components/dist/pobble-avatar');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var React__default =
/*#__PURE__*/
_interopDefaultLegacy(React);

var injectSheet__default =
/*#__PURE__*/
_interopDefaultLegacy(injectSheet);

var _classCallCheck__default =
/*#__PURE__*/
_interopDefaultLegacy(_classCallCheck);

var _createClass__default =
/*#__PURE__*/
_interopDefaultLegacy(_createClass);

var _inherits__default =
/*#__PURE__*/
_interopDefaultLegacy(_inherits);

var _possibleConstructorReturn__default =
/*#__PURE__*/
_interopDefaultLegacy(_possibleConstructorReturn);

var _getPrototypeOf__default =
/*#__PURE__*/
_interopDefaultLegacy(_getPrototypeOf);

var classNames__default =
/*#__PURE__*/
_interopDefaultLegacy(classNames);

var _defineProperty__default =
/*#__PURE__*/
_interopDefaultLegacy(_defineProperty);

var PropTypes__default =
/*#__PURE__*/
_interopDefaultLegacy(PropTypes);

var _extends__default =
/*#__PURE__*/
_interopDefaultLegacy(_extends);

var _objectWithoutProperties__default =
/*#__PURE__*/
_interopDefaultLegacy(_objectWithoutProperties);

var styles$3 = {
  container: {
    fontSize: '90px',
    width: '1em',
    height: '1em',
    borderRadius: '100%',
    backgroundColor: '#ccc'
  }
};
var styles$2 = {
  container: {
    width: '100%',
    height: '100%',
    borderRadius: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover'
  }
};

var ImageAvatar = function ImageAvatar(_ref) {
  var classes = _ref.classes,
      imageUrl = _ref.imageUrl;
  return (
    /*#__PURE__*/
    React__default["default"].createElement("div", {
      className: classes.container,
      style: {
        backgroundImage: "url(".concat(imageUrl, ")")
      }
    })
  );
};

var ImageAvatar$1 = injectSheet__default["default"](styles$2)(ImageAvatar);
var styles$1 = {
  avatar: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid transparent',
    borderRadius: '100%',
    lineHeight: '1',
    color: '#ffffff',
    fontWeight: 'bold',
    fontSize: '0.5em'
  },
  purple: {
    backgroundColor: '#B4A0CA',
    borderColor: '#805FA5'
  },
  green: {
    backgroundColor: '#CEEA50',
    borderColor: '#9FBE17'
  },
  blue: {
    backgroundColor: '#55D1FF',
    borderColor: '#00AFEC'
  },
  red: {
    backgroundColor: '#F2987F',
    borderColor: '#E94D23'
  },
  yellow: {
    backgroundColor: '#FFF199',
    borderColor: '#FEE744'
  },
  darkBlue: {
    backgroundColor: '#4A6CD1',
    borderColor: '#25408F'
  }
};

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf__default["default"](Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf__default["default"](this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn__default["default"](this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var InitialsAvatar =
/*#__PURE__*/
function (_Component) {
  _inherits__default["default"](InitialsAvatar, _Component);

  var _super = _createSuper(InitialsAvatar);

  function InitialsAvatar() {
    _classCallCheck__default["default"](this, InitialsAvatar);

    return _super.apply(this, arguments);
  }

  _createClass__default["default"](InitialsAvatar, [{
    key: "getColorClassName",
    value: function getColorClassName(letter) {
      var classes = this.props.classes;
      var charCode = letter.charCodeAt(0);
      if (charCode < 65 || charCode > 90) return classes.red;
      if (charCode >= 65 && charCode <= 68) return classes.purple;
      if (charCode >= 69 && charCode <= 72) return classes.green;
      if (charCode >= 73 && charCode <= 76) return classes.blue;
      if (charCode >= 77 && charCode <= 80) return classes.red;
      if (charCode >= 81 && charCode <= 84) return classes.yellow;
      if (charCode >= 85 && charCode <= 90) return classes.darkBlue;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          name = _this$props.name,
          classes = _this$props.classes,
          className = _this$props.className;
      var letter = name.charAt(0).toUpperCase();
      var colorClassName = this.getColorClassName(letter);
      return (
        /*#__PURE__*/
        React__default["default"].createElement("span", {
          className: classNames__default["default"](classes.avatar, colorClassName, className)
        }, letter)
      );
    }
  }]);

  return InitialsAvatar;
}(React.Component);

var InitialsAvatar$1 = injectSheet__default["default"](styles$1)(InitialsAvatar);
var styles = {
  container: {
    width: '100%',
    height: '100%',
    backgroundColor: '#fff',
    borderRadius: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  icon: {
    width: '0.6em',
    height: '0.6em',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  }
};
var COLORS_MAP = {
  CgIJCgYPDQA: '#FFF27F',
  Cw4FBAIHCAE: '#7FD6F7',
  BwEABwQJBwc: '#F4A691',
  AgwJBwQPBw8: '#929FC7',
  BwECCgYNAwA: '#CFDE8B',
  DQEMBwkCBgg: '#C0AED7',
  AwkPCw0PDAo: '#A4A4A4',
  Cw4GDQcCDgI: '#FFFFFF'
};

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var getNatureIconPath = function getNatureIconPath(icon) {
  return "https://app.pobble.com/account/files/pupil-avatars/nature/".concat(icon, ".svg");
};

var getObjectIconPath = function getObjectIconPath(icon) {
  return "https://app.pobble.com/account/files/pupil-avatars/objects/".concat(icon, ".svg");
};

var NATURE_ICONS_MAP = {
  AA4HCAEDDgQ: getNatureIconPath('bear'),
  DgAFCAYGDAo: getNatureIconPath('boar'),
  BwcBBgwABgE: getNatureIconPath('bolt'),
  CQEMAwcLAAQ: getNatureIconPath('bouquetofflowers'),
  AAIDCQYFBQk: getNatureIconPath('bunny'),
  CgUOAgwNBgg: getNatureIconPath('cat'),
  BAcFCwUODw8: getNatureIconPath('chicken'),
  Dw8IBAEJBAY: getNatureIconPath('cowface'),
  AA4KCQAAAQk: getNatureIconPath('crescentmoon'),
  BQMKCgcOAAM: getNatureIconPath('dog'),
  CAIDCgIJBQQ: getNatureIconPath('doveofpeace'),
  DQIHDAADCA4: getNatureIconPath('evergreen'),
  BQYKAQEKDAM: getNatureIconPath('fish'),
  Bg8KBQoHBwg: getNatureIconPath('frog'),
  CQ4DAQ8IAgU: getNatureIconPath('frontfacingchick'),
  BAcADw4ODwo: getNatureIconPath('hampster'),
  BwgADwEEAQI: getNatureIconPath('honeybee'),
  DQQHAwILAw8: getNatureIconPath('horseface'),
  AwQBDQUFDAE: getNatureIconPath('koala'),
  CgQIBgoNAQs: getNatureIconPath('ladybeetle'),
  DwkDBA0KBQ0: getNatureIconPath('monkeyface'),
  CQAPDgQLBAM: getNatureIconPath('mouse'),
  DAkHCwsAAgc: getNatureIconPath('mushroom'),
  DwMPDgEJBwY: getNatureIconPath('octopus'),
  DwwPDgkCBwk: getNatureIconPath('palmtree'),
  BggFBwAODA8: getNatureIconPath('pandaface'),
  DAwKAQwLAwk: getNatureIconPath('penguin'),
  DAMOAwsGDQw: getNatureIconPath('pig'),
  Dg4CAQcBCQA: getNatureIconPath('rooster'),
  Cg0EBAkLDg4: getNatureIconPath('snake'),
  AwYIBgUHDwI: getNatureIconPath('spider'),
  DQIDCAUHDAg: getNatureIconPath('sunflower'),
  AgMIAgUDCgc: getNatureIconPath('sunwithface'),
  CwYGBAALDgA: getNatureIconPath('tiger'),
  BwkBDAsOCg8: getNatureIconPath('wolfface')
};
var OBJECT_ICONS_MAP = {
  DgMJDw8EBwM: getObjectIconPath('artistpalette'),
  AA4NDAMLAgE: getObjectIconPath('billiards'),
  DgwCCw0CCQs: getObjectIconPath('bluebook'),
  CQ0MDAYMCwE: getObjectIconPath('darksunglasses'),
  AAYDAAUOCA4: getObjectIconPath('guitar'),
  Dg8DCQ4IAQU: getObjectIconPath('lollipop'),
  CgoLDAgGCQc: getObjectIconPath('lowerleftpencil'),
  CAkMDQIJBAw: getObjectIconPath('microphone'),
  AA8JAwUGAgo: getObjectIconPath('moviecamera'),
  DAELAgcFDg4: getObjectIconPath('musicascend'),
  DgcKAgkKBwY: getObjectIconPath('rugbyfootball'),
  Bw4MAAEEAQA: getObjectIconPath('soccerball'),
  DQEBBQsKAAc: getObjectIconPath('videogame'),
  CgAEDA4BCQk: getObjectIconPath('violin'),
  Bg4HBAUACQM: getObjectIconPath('watermelon')
};

var ICONS_MAP = _objectSpread(_objectSpread({}, NATURE_ICONS_MAP), OBJECT_ICONS_MAP);

var StudentAvatar = function StudentAvatar(_ref) {
  var classes = _ref.classes,
      codeRef = _ref.codeRef,
      colorRef = _ref.colorRef,
      className = _ref.className;
  var color = COLORS_MAP[colorRef] || '#fff';
  var icon = ICONS_MAP[codeRef] ||
  /*#__PURE__*/
  React__default["default"].createElement(React.Fragment, null);
  return (
    /*#__PURE__*/
    React__default["default"].createElement("div", {
      className: classNames__default["default"](classes.container, className),
      style: {
        backgroundColor: color
      }
    }, icon &&
    /*#__PURE__*/
    React__default["default"].createElement("div", {
      className: classes.icon,
      style: {
        backgroundImage: "url(\"".concat(icon, "\")")
      }
    }))
  );
};

var StudentAvatar$1 = injectSheet__default["default"](styles)(StudentAvatar);
var AVATARS_MAP = {
  IMAGE: function IMAGE(avatar) {
    return (
      /*#__PURE__*/
      React__default["default"].createElement(ImageAvatar$1, {
        imageUrl: avatar.url
      })
    );
  },
  INITIALS: function INITIALS(avatar, name) {
    return (
      /*#__PURE__*/
      React__default["default"].createElement(InitialsAvatar$1, {
        name: name || '?'
      })
    );
  },
  STUDENT: function STUDENT(avatar) {
    return (
      /*#__PURE__*/
      React__default["default"].createElement(StudentAvatar$1, {
        colorRef: avatar.color,
        codeRef: avatar.code
      })
    );
  }
};

var PobbleAvatar = function PobbleAvatar(_ref) {
  var classes = _ref.classes,
      avatar = _ref.avatar,
      name = _ref.name,
      className = _ref.className,
      style = _ref.style;
  var avatarType = !avatar ? 'INITIALS' : avatar.url ? 'IMAGE' : avatar.type === 'StudentAvatar' ? 'STUDENT' : 'DEFAULT';
  return (
    /*#__PURE__*/
    React__default["default"].createElement("div", {
      className: classNames__default["default"](classes.container, className),
      style: style
    }, AVATARS_MAP[avatarType] && AVATARS_MAP[avatarType](avatar, name))
  );
};

PobbleAvatar.propTypes = {
  /** Avatar object coming directly from BE, no need to map anything */
  avatar: PropTypes__default["default"].object,

  /** The first letter of this property will serve as an initials fallback for avatar */
  name: PropTypes__default["default"].string,

  /** Additional className if you want to restyle component or add some margins */
  className: PropTypes__default["default"].string,

  /** Style object to change appearance of the avatar */
  style: PropTypes__default["default"].object
};
var avatarContainer = injectSheet__default["default"](styles$3)(PobbleAvatar);
var _excluded = ["me"];

var MyAvatar = function MyAvatar(_ref) {
  var me = _ref.me,
      props = _objectWithoutProperties__default["default"](_ref, _excluded);

  return (
    /*#__PURE__*/
    React__default["default"].createElement(pobbleAvatar.PobbleAvatar, _extends__default["default"]({
      avatar: me.account.avatar,
      name: me.account.display_name
    }, props))
  );
};

var myAvatar = pobbleUser.withMe(MyAvatar);
exports.MyAvatar = myAvatar;
exports.PobbleAvatar = avatarContainer;
exports.STUDENT_AVATAR_COLORS_MAP = COLORS_MAP;
exports.STUDENT_AVATAR_ICONS_MAP = ICONS_MAP;